import React, { useEffect, useState } from "react";
import { api, assetUrl } from "@/lib/api";
import { ArticleRow, SectionTitle } from "@/components/ArticleCards";
import { useI18n } from "@/lib/i18n";

export default function CurrentIssue() {
  const { t } = useI18n();
  const [issue, setIssue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/issues", { params: { current: true } }).then((r) => {
      const list = r.data || [];
      setIssue(list[0] || null);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="py-24 text-center font-serif text-[#001F3F]/60">{t("common.loading")}</div>;
  if (!issue) return (
    <div className="py-24 max-w-3xl mx-auto px-6 text-center" data-testid="current-issue-empty">
      <SectionTitle subtitle={t("current_issue.empty_subtitle")}>{t("current_issue.title")}</SectionTitle>
      <div className="border border-dashed border-gray-200 p-10 font-serif text-[#001F3F]/60">
        {t("current_issue.empty")}
      </div>
    </div>
  );

  return (
    <div className="py-16 md:py-24" data-testid="current-issue-page">
      <div className="max-w-4xl mx-auto px-6">
        <SectionTitle subtitle={issue.title || `Volume ${issue.volume}, Issue ${issue.issue} — ${issue.year}`}>
          {t("current_issue.title")}
        </SectionTitle>
        {issue.cover_image_url && (
          <div className="flex justify-center mb-10">
            <img src={assetUrl(issue.cover_image_url)} alt="" className="max-h-80 border border-gray-200" />
          </div>
        )}
        {issue.description && <p className="font-serif text-base text-[#0A1118] leading-relaxed mb-10 max-w-2xl mx-auto text-center">{issue.description}</p>}

        <div>
          {(issue.articles_preview || []).length === 0 ? (
            <div className="text-center py-16 font-serif text-[#001F3F]/60 border border-dashed border-gray-200">{t("current_issue.no_articles")}</div>
          ) : (
            (issue.articles_preview || []).map((a) => <ArticleRow key={a.id} article={a} />)
          )}
        </div>
      </div>
    </div>
  );
}
